import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { PatientPersonalInfo } from '../models/verifypatient/verifypatient';
import { SavePastHX } from '../models/intake/pastHospitalization';

@Injectable({
  providedIn: 'root'
})
export class PastHospitalizationService {

  constructor(private genericService: GenericUtilityService) { }

  getPastHospHX(PatientAccount: any, PracticeCode: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetPastHospitalization?PatientAccount=" + PatientAccount + '&PracticeCode=' + PracticeCode);
  }

  savePastHospHX(data: SavePastHX) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SaveUpdatePastHospitalization", data);
  }

  deletePastHospHX(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "DeletePastHospitalization", data);
  }
  noKnownPastHospHistory(PatientAccount: any, PracticeCode: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownPastHspitalizationForPatient", { PatientAccount: PatientAccount, PracticeCode: PracticeCode });
  }
}
